import { apiFetch } from '../admin/jscontrol/apiClient';

const addressFetchOptions = { useStorefrontAuth: true };

export async function fetchAddresses({ userId, pageIndex = 1, pageSize = 50 } = {}) {
  const params = new URLSearchParams({
    pageIndex: String(pageIndex),
    pageSize: String(pageSize),
    search: '',
    sortColumn: 'CreatedAt',
    sortBy: 'DESC',
  });
  if (userId) params.set('userId', String(userId));

  const { data } = await apiFetch(`/Address/GetAll?${params}`, addressFetchOptions);
  const rows = Array.isArray(data?.data) ? data.data : [];
  return rows;
}

export async function fetchAddressById(addressId) {
  const { data } = await apiFetch(`/Address/GetById/${addressId}`, addressFetchOptions);
  if (data?.success === false) throw new Error(data?.message || 'Address not found.');
  return data?.data ?? data;
}

export async function createAddressApi(payload) {
  const { data } = await apiFetch('/Address/Create', {
    method: 'POST',
    ...addressFetchOptions,
    data: payload,
  });
  if (data?.success === false) throw new Error(data?.message || 'Could not save address.');
  return data?.data?.AddressId ?? data?.data?.addressId ?? null;
}

export async function updateAddressApi(payload) {
  const { data } = await apiFetch('/Address/Update', {
    method: 'PUT',
    ...addressFetchOptions,
    data: payload,
  });
  if (data?.success === false) throw new Error(data?.message || 'Could not update address.');
}

export async function deleteAddressApi(addressId) {
  const { data } = await apiFetch(`/Address/Delete/${addressId}`, {
    method: 'DELETE',
    ...addressFetchOptions,
  });
  if (data?.success === false) throw new Error(data?.message || 'Could not delete address.');
}
